export default "__VITE_ASSET__P0yRS2f8__"